module.exports = __webpack_public_path__ + "static/media/anipod01.1508c50d.jpg";